"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("../../hooks");
var Scroll = function (_a) {
    var _b;
    var _c = _a.el, ScrollElement = _c === void 0 ? 'div' : _c, children = _a.children, className = _a.className, maxHeight = _a.height, maxWidth = _a.width, _d = _a.horizontal, horizontal = _d === void 0 ? 'auto' : _d, _e = _a.vertical, vertical = _e === void 0 ? 'auto' : _e, _f = _a.scrollIndicator, scrollIndicator = _f === void 0 ? false : _f, scrollbar = _a.scrollbar, props = __rest(_a, ["el", "children", "className", "height", "width", "horizontal", "vertical", "scrollIndicator", "scrollbar"]);
    var scrollbarRef = react_1.default.useRef(null);
    var _g = hooks_1.useScrollPosition(scrollbarRef), top = _g.top, right = _g.right, bottom = _g.bottom, left = _g.left;
    var ScrollClasses = classnames_1.default('Scroll', className, (_b = {},
        _b["Scroll--of-x-" + horizontal] = horizontal,
        _b["Scroll--of-y-" + vertical] = vertical,
        _b['Scroll--scrollable-top'] = top,
        _b['Scroll--scrollable-right'] = right,
        _b['Scroll--scrollable-bottom'] = bottom,
        _b['Scroll--scrollable-left'] = left,
        _b['Scroll--hidden-scrollbar'] = scrollbar === 'hidden',
        _b['Scroll--height-auto'] = !maxHeight,
        _b['Scroll--width-auto'] = !maxWidth,
        _b));
    var shadows = (react_1.default.createElement("div", { className: "Scroll__Shadows" },
        react_1.default.createElement("div", { className: "Shadow--top" }),
        react_1.default.createElement("div", { className: "Shadow--right" }),
        react_1.default.createElement("div", { className: "Shadow--bottom" }),
        react_1.default.createElement("div", { className: "Shadow--left" })));
    var styles = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
    };
    return (react_1.default.createElement(ScrollElement, { className: ScrollClasses, style: styles },
        scrollIndicator && shadows,
        react_1.default.createElement("div", __assign({ className: "Scroll__Scrollbar", ref: scrollbarRef }, props), children)));
};
exports.Scroll = Scroll;
//# sourceMappingURL=Scroll.js.map